<template>
  <el-dialog 
    v-if="visible"
    :visible.sync="visible"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :show-close="false"
    append-to-body
    width="60%"
    center
    >
    <dialog-header
      slot="title"
      :title="$t('public.view') + ' ' + $t('public.vehicle')"
      icon="icon-dialog-look"
      @close="closeDialog"
    />
    <vue-linetitle>
      <div style="height:60vh">
        <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
          <el-table
            ref="tableList"
            v-loading="listLoading"
            size="mini"
            :data="list"
            :max-height="tableHeight"
            :header-row-style="headerRowStyle"
            :row-style="rowStyle"
            :header-cell-style="headerCellStyle"
            border
            fit
            style="width: 100%"
          >
            <el-table-column
              type="index"
              width="50">
            </el-table-column>
            <el-table-column
              v-for="(item,index) in tableList"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :min-width="item.width"
              :align="item.position"
              :sortable="item.sortable"
              >
              <template slot-scope="scope">
                <vue-licenseplate
                  v-if="item.prop==='licensePlate'"
                  :types="0"
                  :licensepalte="scope.row[item.prop]"
                  :area="scope.row['areaName']"
                />
                <span v-else>{{scope.row[item.prop]}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
    </vue-linetitle>
  </el-dialog>
</template>
<script>
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { geofencVehicleListUrl } from '@/api/electric/geofence'
import resolve from '@/api/resolve'

export default {
  mixins: [otherHeight, tableStyle],
  props: {
    visible: Boolean,
    id: String
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.listLoad()
      }
    }
  },
  data() {
    return {
      tableList: [
        {
          label: this.$t("public.licensePlate"),
          prop: "licensePlate",
          width: this.$t("carManagement.tableWidth.licensePlate")
        },
        {
          label: this.$t("carManagement.brand"),
          prop: "brandName",
          width: this.$t("carManagement.tableWidth.brandName")
        },
        {
          label: this.$t("carManagement.series"),
          prop: "seriesName",
          width: this.$t("carManagement.tableWidth.seriesName"),
          checked: false
        },
        {
          label: this.$t("carManagement.model"),
          prop: "modelName",
          width: this.$t("carManagement.tableWidth.modelName")
        }
      ],
      list: [],
      listLoading: false
    }
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      this.list = []
      this.$emit('update:visible', false)
    },
    listLoad() {
      if (!this.visible) {
        return
      }
      this.listLoading = true
      this.$http.post(resolve(geofencVehicleListUrl, this.id)).then(({ data }) => {
        this.list = data.data
      }).finally(()=>{
        this.listLoading = false
      })
    }
  }
}
</script>
